// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".StatsButton__icon___T0HRQ{stroke-width:0}.StatsButton__button___ZBep2{background-color:unset}.StatsButton__button___ZBep2:active{background-color:unset}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/reservations/service/StatsButton.scss"],"names":[],"mappings":"AAAA,2BACE,cAAA,CAGF,6BACE,sBAAA,CAEA,oCACE,sBAAA","sourcesContent":[".icon {\n  stroke-width: 0;\n}\n\n.button {\n  background-color: unset;\n\n  &:active {\n    background-color: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "StatsButton__icon___T0HRQ",
	"button": "StatsButton__button___ZBep2"
};
export default ___CSS_LOADER_EXPORT___;
